import { CsrfToken } from '@brainfocus/web/components/csrfToken/csfdToken';
import { TextInput } from '@brainfocus/web/components/text_input/text_input';

export function ResetPassword() {
    return (
        <div class='bf-ui-content'><div class='container'>
            <div class='flex-column align-items-center'>
                <h1>Password Reset</h1>
                <p class='mb-4'>Please fill in your email to reset your password.</p>
                <form method='POST' class='d-contents'>
                    <TextInput output='string' type='email' name='email' label='E-mail' />
                    <CsrfToken />
                    <button type='submit' class='bf-action'>Continue</button>
                </form>
            </div>
        </div></div>
    );
}
